export default __webpack_public_path__ + "graph-center.png?75c621b536b77736ca320e7820ee890f";